import React from "react";
import StepShell from "./StepShell";

// Generic "pick one option" step, driven by an entry of copy.choices.
const ChoiceStep = ({ config, value, onSelect, onBack }) => (
  <StepShell title={config.title} subtitle={config.subtitle} onBack={onBack}>
    <div
      className={`rp-options rp-options--${config.layout}`}
      role="group"
      aria-label={config.title}
    >
      {config.options.map((option) => (
        <button
          key={option}
          type="button"
          className={`rp-choice${value === option ? " is-selected" : ""}`}
          aria-pressed={value === option}
          onClick={() => onSelect(option)}
        >
          {option}
        </button>
      ))}
    </div>
  </StepShell>
);

export default ChoiceStep;
